import { render } from "./KSDeleteDoubles.vue?vue&type=template&id=8a4216d0"
import script from "./KSDeleteDoubles.vue?vue&type=script&lang=js"
export * from "./KSDeleteDoubles.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__